// @flow
import { CaretRight, MagnifyingGlass } from '@phosphor-icons/react'
import { Input } from 'antd'
import InfiniteScroller from 'components/InfiniteScroller'
import usePermissions from 'hooks/usePermissions'
import { isNil } from 'lodash'
import * as React from 'react'
import type { FormWithPdfApiResponse } from 'types/form-with-pdf-api-response'
import Icons from 'ui/Icons'
import { isFilledArray } from 'utils/helpers'

import { useUpdateURLSearchParams } from '@/hooks/useQuery'
import useSearchParams from '@/hooks/useSearchParams'

type Props = {
  forms: Array<FormWithPdfApiResponse>,
  onAddAll: () => void,
  handleScrollToBottom: () => void,
  onAddForm: (FormWithPdfApiResponse) => void,
}

function CreateUpdatePacketFormList({
  forms,
  onAddAll,
  handleScrollToBottom,
  onAddForm,
}: Props): React.Node {
  const { canEditPacketForm } = usePermissions()
  const searchParams = useSearchParams()
  const updateParams = useUpdateURLSearchParams()

  const search = (searchParams.get('search') || '').toLocaleLowerCase()

  if (!canEditPacketForm) return null

  const filteredForms = forms.filter((form) =>
    form?.name?.toLocaleLowerCase().includes(search)
  )

  return (
    <div className="relative mr-2 flex w-1/2 flex-col rounded-md border bg-white shadow-sm">
      <div className="flex w-auto flex-shrink-0 flex-col justify-between gap-2 rounded-t-md border-b border-gray-200 bg-gray-50 px-3 py-3 text-left font-medium text-gray-900">
        <div className="flex w-full justify-between">
          <span>Forms</span>
          {forms.length && (
            <button onClick={onAddAll}>
              <Icons.ChevronDoubleRight size={4} />
            </button>
          )}
        </div>
        <Input
          defaultValue={search}
          onChange={(e) => updateParams(['search', e.target.value])}
          placeholder="Search form"
          prefix={<MagnifyingGlass className="!bg-white text-gray-800" />}
        />
      </div>
      <InfiniteScroller onScrollToBottom={handleScrollToBottom}>
        <div className="flex flex-col">
          {isFilledArray(filteredForms) &&
            filteredForms.map((form) => {
              if (isNil(form?.id) || isNil(form?.name)) return null
              return (
                <button
                  className="flex flex-shrink-0 items-center border-b border-gray-200 px-3 py-2.5 hover:bg-blue-100/20"
                  key={form.id}
                  onClick={() => onAddForm(form)}
                >
                  <p className="flex flex-1 pr-3 text-left text-sm leading-5 text-gray-800">
                    {form.name}
                  </p>
                  <CaretRight className="text-gray-400" weight="bold" />
                </button>
              )
            })}
        </div>
      </InfiniteScroller>
    </div>
  )
}

export default CreateUpdatePacketFormList
